<style lang="less" scoped>
.tabs {
  width: 100%;
  //   flex-grow: 1;
  height: 55px;
  //   background: rgba(0, 0, 0, 0) !important;
  //   border: none !important;
  line-height: 55px;
  display: flex;
  flex-direction: row;
  color: #8f9bb3;
  border-bottom: 1px solid #eaf1ff;
  .tab_con {
    // width: 25%;
    // width: 75px;
    font-weight: 600;
    font-size: 12px;
    height: 55px;
    padding: 0 20px;
    text-align: center;
    // padding-bottom: 10px;
    cursor: pointer;

    .selectActive {
      //   width: 30%;
      height: 55px;
      padding: 0 20px;
      margin: 0 auto;
      color: #000;
      font-size: 14px;
      font-weight: 600;
      border-bottom: 3px solid #3291f8;
    }
  }
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="tabs">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          class="tab_con"
          @click="tabChange(item)"
        >
          <div :class="{ selectActive: item.value == tabSelect }">
            {{ item.label }}
          </div>
        </div>
      </div>
      <!-- 共享开关信息 -->
      <pileDetail v-if="tabSelect == 1" />
      <!-- 报文日志 -->
      <logList v-if="tabSelect == 3" />
      <!-- 故障信息 -->
      <faultList v-if="tabSelect == 4" />
      <!-- 用户信息 -->
      <userList v-if="tabSelect == 5" />
      <!-- 私桩共享信息 -->
      <publicPileDetail v-if="tabSelect == 6" />
      <!-- 私桩共享订单信息 -->
      <reservationList v-if="tabSelect == 7" />
    </div>
  </div>
</template>

<script>
import pileDetail from "./pile-detaill.vue";
import logList from "./log-list.vue";
import faultList from "./fault-list.vue";
import userList from "./user-list.vue";
import reservationList from "./reservation-list.vue";
import publicPileDetail from "./pile-datail.vue";
export default {
  components: {
    pileDetail,
    logList,
    faultList,
    userList,
    publicPileDetail,
    reservationList,
  },
  data() {
    return {
      listBreadCrumb: [
        {
          type: "title",
          name: "首页",
        },
        {
          type: "router",
          name: " 充电桩设备列表",
          router: "pileList",
        },
        {
          type: "title",
          name: "详情",
        },
      ],
      tabList: [
        {
          value: 1,
          label: "共享开关信息",
        },
        {
          value: 3,
          label: "报文日志",
        },
        {
          value: 4,
          label: "故障信息",
        },
        {
          value: 5,
          label: "用户信息",
        },
        {
          value: 6,
          label: "私桩共享信息",
        },
        {
          value: 7,
          label: "私桩共享订单信息",
        },
      ],
      tabSelect: 1,
    };
  },
  methods: {
    tabChange(tab) {
      this.listBreadCrumb[1].name = tab.label;
      this.tabSelect = tab.value;
    },
  },
  mounted() {
    this.tabSelect = this.$route.query.parent || "1";
  },
  unmounted() {
    this.$store.commit("setPileObj", null);
    this.$store.commit("setCustObj", null);
  },
  destroyed() {
    this.$store.commit("setPileObj", null);
    this.$store.commit("setCustObj", null);
  },
};
</script>